
import Vue from 'vue'
import UiCard from '@/components/UiCard.vue'
import UiButton from '@/components/UiButton.vue'
import UiIcon from '@/components/UiIcon.vue'

export default Vue.extend({
  name: "Signup",
  data(){
    return {
      isSignedIn: this.$store.getters.userSignedIn,
      showSignIn: false,
      loadingSignup: false,
      invitation: this.$store.getters.invitation,
      password: "",
      passwordConfirm: "",
      errorCode: ""
    }
  },
  computed: {
    organization(){ return this.$store.getters.organization },
  },
  methods: {
    userEmail(){ return this.$store.getters.userEmail },
    userId(){ return this.$store.getters.userId },
    organizationUser(){ return this.$store.getters.organizationUser },
    handleToggleSigninSignup(){
      this.showSignIn = !this.showSignIn
    },
    async handleSignin(){
      this.loadingSignup = true

      if(await this._trySignIn(this.invitation.email, this.password)){
        // Update organization user if present: 
        await this.$store.dispatch('loadOrganizationUser', this.userId())
        // Success. Show "join" button
        this.isSignedIn = true
        this.errorCode = ""
      }

      this.loadingSignup = false
    },
    async handleSignup(){
      this.loadingSignup = true

      // make sure the password was typed in twice:
      if(this.password != this.passwordConfirm){
        this.errorCode = "signup/passwords-dont-match"
        this.loadingSignup = false
        return
      }

      // Try Signup:
      if(await this._trySignUp(this.invitation.email, this.password)){
        // Update organization user if present: 
        await this.$store.dispatch('loadOrganizationUser', this.userId())
        // Success. Show "join" button
        this.isSignedIn = true
        this.errorCode = ""
      }

      this.loadingSignup = false
    },
    async handleLogout(){
      await this.$store.dispatch('signOutUser')
      this.isSignedIn = false
      this.errorCode = ""
    },
    async handleJoinClick(){
      this.loadingSignup = true

      try {
        // Confirm invitation code is still relevant and active
        const invitationId = this._getFreshInvitationId()
        if(!invitationId) throw({displayError: this.$t("error.invitationIdMissing")})
        // Confirm user is not part of organization already
        if(this.organizationUser()?.isAuthorized) throw({displayError: this.$t("error.alreadyInOrganization", {orgId: this.organization.id})})
        // Update Invitation
        await this.$store.dispatch('updateInvitationUser', {
          userId: this.userId(),
          email: this.userEmail(),
          name: this.invitation.name,
          role: this.invitation.role // Important: Cannot be changed at this point!
        })
        // Wait until user is created in the organization:
        await this.$store.dispatch('listenUntilOrganizationUserLoaded', this.userId())
        // Go to organization page
        this.$router.push(`/${this.organization.id}`)
      } catch (error) {
        console.error(error)

        if(error.displayError) alert(error.displayError)
        else alert(this.$t('error.userCreationFailed'))
      } finally {
        this.loadingSignup = false
      }
    },
    async _trySignUp(email: string, password: string){
      try {
        await this.$store.dispatch('signupUser', {
          email: this.invitation.email, 
          password: this.password
        })

        return true
      } catch (error) {
        // Set error code containing information about 
        this.errorCode = error.code // "signup/email-in-use" : "signup/failed"
        console.error(error)
        return false
      }
    },
    async _trySignIn(email: string, password: string){
      try {
        await this.$store.dispatch('signInUser', {
          email: this.invitation.email, 
          password: this.password
        })

        return true
      } catch (error) {
        // Set error code for user
        this.errorCode = "signin/failed"
        console.error(error)
        return false
      }
    },
    async _getFreshInvitationId(){
      if(
        this.$store.getters.invitation &&
        this.$store.getters.invitation.id
      ){
        return this.$store.getters.invitation.id
      }else{
        console.info("Invitation ID from state went missing. Getting new one ...")
        const newInvitation = await this.$store.dispatch('loadInvitation', this.$route.params.invitationKey)
        return newInvitation ? newInvitation.id : undefined
      }
    },
  },
  components: {
    UiCard,
    UiButton,
    UiIcon,
  }
})
